import { HStack, Input, InputGroup, InputLeftElement, Text, VStack, } from "@chakra-ui/react";
import { percentsToPx, pxToPercents, ToggleButton } from "@govisupro/controls";
import React, { useContext } from "react";
import { GiHorizontalFlip, GiVerticalFlip } from "react-icons/gi";
import { useServices } from "../hooks/useServices";
import { StudioContext } from "../studioContext";
export const LayoutItemDetail = () => {
    var _a, _b, _c, _d, _e;
    const { layoutService } = useServices();
    const { layoutItems, selectedLayoutItemId, widgets, loadedFonts, screenWidth, screenHeight, isLocked, } = useContext(StudioContext);
    const layoutItem = layoutItems.find((layoutItem) => layoutItem.id === selectedLayoutItemId);
    const widget = widgets.find((w) => w.name === (layoutItem === null || layoutItem === void 0 ? void 0 : layoutItem.widgetName));
    const WidgetControlPanel = widget === null || widget === void 0 ? void 0 : widget.controlPanel;
    return (React.createElement(VStack, { spacing: "24px", alignItems: "flex-start" }, layoutItem ? (React.createElement(React.Fragment, null,
        React.createElement(VStack, null,
            React.createElement(ToggleButton, { label: "Unit\u00E9", defaultValue: (_a = layoutItem.unit) !== null && _a !== void 0 ? _a : "%", options: [
                    { content: "%", value: "%" },
                    { content: "px", value: "px" },
                ], onChange: (unit) => {
                    let newLayoutItem;
                    if (unit === "%") {
                        newLayoutItem = {
                            ...layoutItem,
                            unit,
                            x: pxToPercents(layoutItem.x, screenWidth),
                            y: pxToPercents(layoutItem.y, screenHeight),
                            width: pxToPercents(layoutItem.width, screenWidth),
                            height: pxToPercents(layoutItem.height, screenHeight),
                        };
                    }
                    if (unit === "px") {
                        newLayoutItem = {
                            ...layoutItem,
                            unit,
                            x: percentsToPx(layoutItem.x, screenWidth),
                            y: percentsToPx(layoutItem.y, screenHeight),
                            width: percentsToPx(layoutItem.width, screenWidth),
                            height: percentsToPx(layoutItem.height, screenHeight),
                        };
                    }
                    layoutService.updateLayoutItem(newLayoutItem);
                } }),
            React.createElement(HStack, null,
                React.createElement(InputGroup, null,
                    React.createElement(InputLeftElement, { pointerEvents: "none", children: React.createElement(Text, null, "X"), color: "gray.500" }),
                    React.createElement(Input, { value: layoutItem.x, onChange: (e) => layoutService.updateLayoutItem({
                            ...layoutItem,
                            x: e.currentTarget.value,
                        }), disabled: isLocked })),
                React.createElement(InputGroup, null,
                    React.createElement(InputLeftElement, { pointerEvents: "none", children: React.createElement(Text, null, "Y"), color: "gray.500" }),
                    React.createElement(Input, { value: layoutItem.y, onChange: (e) => layoutService.updateLayoutItem({
                            ...layoutItem,
                            y: e.currentTarget.value,
                        }), disabled: isLocked }))),
            React.createElement(HStack, null,
                React.createElement(InputGroup, null,
                    React.createElement(InputLeftElement, { pointerEvents: "none", children: React.createElement(GiHorizontalFlip, null), color: "gray.500" }),
                    React.createElement(Input, { disabled: (widget === null || widget === void 0 ? void 0 : widget.resize) && typeof (widget === null || widget === void 0 ? void 0 : widget.resize) !== "boolean"
                            ? !((_b = widget === null || widget === void 0 ? void 0 : widget.resize) === null || _b === void 0 ? void 0 : _b.left) && !((_c = widget === null || widget === void 0 ? void 0 : widget.resize) === null || _c === void 0 ? void 0 : _c.left)
                            : false || isLocked, value: layoutItem.width, onChange: (e) => layoutService.updateLayoutItem({
                            ...layoutItem,
                            width: e.currentTarget.value,
                        }) })),
                React.createElement(InputGroup, null,
                    React.createElement(InputLeftElement, { pointerEvents: "none", children: React.createElement(GiVerticalFlip, null), color: "gray.500" }),
                    React.createElement(Input, { disabled: (widget === null || widget === void 0 ? void 0 : widget.resize) && typeof (widget === null || widget === void 0 ? void 0 : widget.resize) !== "boolean"
                            ? !((_d = widget === null || widget === void 0 ? void 0 : widget.resize) === null || _d === void 0 ? void 0 : _d.top) && !((_e = widget === null || widget === void 0 ? void 0 : widget.resize) === null || _e === void 0 ? void 0 : _e.bottom)
                            : false || isLocked, value: layoutItem.height, onChange: (e) => layoutService.updateLayoutItem({
                            ...layoutItem,
                            height: e.currentTarget.value,
                        }) })))),
        WidgetControlPanel && (React.createElement(WidgetControlPanel, { layoutItem: layoutItem, loadedFonts: loadedFonts, onUpdate: (data) => layoutService.updateLayoutItem({
                ...layoutItem,
                widget: {
                    ...layoutItem.widget,
                    data: data,
                },
            }) })))) : (React.createElement("div", null))));
};
